import React, { useEffect, useState } from "react";
import { Redirect, Route } from "react-router-dom";
import { redirectTo } from "../redirectToPath";
import { useSelector } from "react-redux";
import { Loader } from "semantic-ui-react";
import PublicLayout from "../../../layout/publicLayOut";
import { getBrandIntroductionPath } from "../pathUtils";

const PublicRoute = (props) => {

    const { component: Component, isuserRole = '', ...rest } = props;
    let token = sessionStorage.getItem("ssoToken")
    const [isLoader] = useState(false)
    const profileDetail = useSelector(state => state?.profileReducer?.profileDetail)
    const [userRole, setUserRole] = useState('')

    useEffect(() => {
        let role = profileDetail?.data?.user?.role
        if (role) {
            setUserRole(role)
        }
        // eslint-disable-next-line
    }, [profileDetail?.data?.user?.role])

    const SwitchPage = (type) => {
        let switchPathName = redirectTo[type] || '/'
        if((sessionStorage.getItem("userRole") === 'entrepreneur') && token) {
            return  <Redirect to={getBrandIntroductionPath(window.location.pathname)} />
        }
        return <Redirect to={switchPathName} />
    }

    return !token ?
        <>
            <PublicLayout redirectTo={props?.redirectTo}>
                {!isLoader ?
                    !isuserRole.includes(userRole) ?
                        <Route  {...rest} render={props => (
                            <Component {...props} />
                        )} />
                        : SwitchPage(userRole)
                    :
                    <div className="h-full w-full flex flex-col items-center justify-center">
                        <Loader size='big' active inline='centered' />
                    </div>
                }
            </PublicLayout>
        </>
        : SwitchPage()
}
export default PublicRoute;
